// @ts-nocheck
import React from "react";
import ImageCard from "./ImageCard.js";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function ImageGallery() {
  const { t } = useTranslation();

  const images = useSelector((state) => state.images);
  return (
    <div>
      <h1>{t("description.Choose an image to color")}</h1>
      <div id="image-gallery">
        {images.map((image) => (
          <ImageCard image={image} key={image.id} />
        ))}
      </div>
    </div>
  );
}
